export default __webpack_public_path__ + "e477ce78ced3ef447ddfd290ee2a0935.svg";